<script>
import { angularInvoke } from "/vodalys/vvuejs";

export default {
  components: {},
  methods: {
    customize : function ()
    {
      this.openModal = true
      /*
      console.log('customize')
        angularInvoke(function (v17Modal, $rootScope, $rootElement) {
          v17Modal.modal($rootScope, $rootElement.find("body"), 'plan-custom-edit-ng-component', {}, true)
      });
      */
    }
  },
  props: ["component", "handler"],
  data: function () {
    return {
      openModal : false
    };
  },
  computed: {
  }
};
</script>

<template>
<div>
  <plan-custom-edit 
    v-if="component.edit"
    :handler="handler"
    :component="component.edit"></plan-custom-edit>

  <div>{{component.title ? component.title : 'no plan'}}</div>
  <div v-if="component.expires_at > 0">Expiration : {{component.expires_at * 1000 | angularFilter("dd MMMM yyyy", "date")}}</div>
  <div><a class="v17-link" @click="handler.action(component, 'customize')" style="color:#027AC6">customize</a></div>
</div>
</template> 

<style lang="scss">
</style>